import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  MenuItem,
  Select,
  Divider,
  Grid,
  Autocomplete,
  FormControl,
  InputLabel,
  Tabs,
  Tab,
  Checkbox,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Print as PrintIcon,
  Add,
} from "@mui/icons-material";
import axios from "axios";
import { toast } from "react-toastify";
import DynamicTable from "../../../components/lab-dynamic-table";
import "react-toastify/dist/ReactToastify.css";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { useSelector } from "react-redux";
import Restrict from "../../Restrict";
import * as XLSX from "xlsx";
import DateRangeSelector from "../../../components/DateRangeSelector";
import { formatDateTime, formatDateOnly } from "../../../utils/dateTimeUtils";
interface ExpenseCategory {
  _id: string;
  categoryName: string;
  projectId: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
  isDeleted: boolean;
  isActive: boolean;
}
interface Expense {
  doctorInfo: {
    id: string;
    fullName: string;
  };
  doctorName: string;
  _id: string;
  expenseCategoryId: string;
  description: string;
  attachment: string;
  attachmentPath?: string;
  billAttachmentUrl?: string | null;
  amount: number;
  date: string;
  paymentMode: string;
  paymentStatus?: string;
  paidAmount?: number;
  pendingAmount?: number;
  voucher: number;
  createdAt: string;
  updatedAt?: string;
  updatedBy: {
    _id: string;
    fullName?: string;
    firstName?: string;
  };
  isDeleted: boolean;
  isActive: boolean;
  createdBy: {
    _id: string;
    fullName: string;
    firstName: string;
  };
  category: {
    _id: string;
    categoryName: string;
  };
  expenseCategory?: string;
  // Patient information for processed expenses
  patientInfo?: {
    mrn: number | string;
    patientName: string;
    guardiansName?: string;
    phonNumber?: string;
    gender?: string;
  };
  mrn?: number | string;
  patientName?: string;
}
const ExpenseCategory: React.FC = () => {
  const [categoryName, setCategoryName] = useState<string>("");
  const [categories, setCategories] = useState<ExpenseCategory[]>([]);
  const [editCategoryId, setEditCategoryId] = useState<string | null>(null);
  const [editCategoryName, setEditCategoryName] = useState<string>("");
  const [openMainDialog, setOpenMainDialog] = useState<boolean>(false);
  const [expenses, setExpenses] = useState<Expense[]>([]);
  const [selectedDoctor, setSelectedDoctor] = useState<any | null>(null);
  const [doctors, setDoctors] = useState<any[]>([]);
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(20);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [categorySummaryData, setCategorySummaryData] = useState<any[]>([]);

  // --- NEW: State to manage the active tab ---
  const [activeTab, setActiveTab] = useState(0);
  const [open, setOpen] = useState(false);
  const totalAmount =
    activeTab === 2
      ? categorySummaryData?.reduce(
          (sum, item) => sum + (item.totalAmount || 0),
          0
        )
      : expenses?.reduce(
          (sum, expense) => sum + parseFloat(expense.amount.toString()),
          0
        );
  
  const totalPaidAmount = expenses?.reduce(
    (sum, expense) => sum + (expense.paidAmount || 0),
    0
  );

  const totalUnpaidAmount = expenses?.reduce(
    (sum, expense) => sum + (expense.pendingAmount || 0),
    0
  );

  const [expenseForm, setExpenseForm] = useState<{
    expenseCategory: string;
    expenseCategoryId: string;
    description: string;
    attachment: File | string | null;
    amount: number;
    date: string;
    paymentMode: string;
    paymentStatus: string;
  }>({
    expenseCategory: "",
    expenseCategoryId: "",
    description: "",
    attachment: null,
    amount: 0,
    date: new Date().toISOString().slice(0, 10),
    paymentMode: "Cash",
    paymentStatus: "Paid",
  });
  const today = new Date().toISOString().split("T")[0];
  const [editExpense, setEditExpense] = useState<Expense | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<string>(
    new Date().toISOString().slice(0, 10)
  );
  const [endDate, setEndDate] = useState<string>(
    new Date().toISOString().slice(0, 10)
  );
  const [openDeleteDialog, setOpenDeleteDialog] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<{
    id: string;
    type: "expense" | "category";
  } | null>(null);
  const profile = useSelector((state: any) => state.profileSlice.profile);
  const projectProfile = useSelector(
    (state: any) => state.projectProfileSlice.projectProfile
  );

  const hospitalName = projectProfile?.hospitalName || "N/A";
  const expensePermissions = profile?.data?.accessConfigurations?.Expense || {};
  const [selectedCategory, setSelectedCategory] = useState<any | null>(null);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState<string>("");
  const [selectedPaymentStatus, setSelectedPaymentStatus] = useState<string>("");
  const [users, setUsers] = useState<any[]>([]);
  const [selectedCreatedBy, setSelectedCreatedBy] = useState<any | null>(null);
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [dateRange, setDateRange] = useState("Today");
  const [openImageModal, setOpenImageModal] = useState<boolean>(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState<string | null>(null);
  const [selectedExpenseIds, setSelectedExpenseIds] = useState<string[]>([]);
  const [markingPaid, setMarkingPaid] = useState(false);
  const [openMarkPaidDialog, setOpenMarkPaidDialog] = useState(false);
  const initialForm = {
    expenseCategory: "",
    expenseCategoryId: "",
    description: "",
    attachment: null,
    amount: 0,
    date: new Date().toISOString().slice(0, 10),
    paymentMode: "Cash",
    paymentStatus: "Paid",
  };
  const [editClick, setEditClick] = useState(false);
  const [updatedExpenseId, setUpdatedExpenseId] = useState<string | null>(null);
  useEffect(() => {
    if (expensePermissions.view_module) {
      fetchCategories();
    }
  }, [expensePermissions.view_module, expensePermissions.view_report]);

  useEffect(() => {
    if (activeTab === 2) {
      fetchCategorySummary();
    } else {
      fetchExpenses();
    }
    setSelectedExpenseIds([]);
  }, [fromDate, toDate, selectedCategory, activeTab, selectedDoctor, selectedPaymentMode, selectedPaymentStatus, selectedCreatedBy]);
  useEffect(() => {
    fetchDoctors();
    fetchUsers();
  }, []);

  // Reset activeTab to 0 if user doesn't have access to the second tab and currently on tab 1
  useEffect(() => {
    if (
      projectProfile?.departmentsAccess?.includes("income_expense") &&
      !projectProfile?.departmentsAccess?.includes("Account") &&
      (activeTab === 1 || activeTab === 2)
    ) {
      setActiveTab(0);
    }
  }, [projectProfile?.departmentsAccess, activeTab]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };
  const handleDateRangeChange = (value: string) => {
    setDateRange(value);
    if (value !== "custom") {
      fetchExpenses();
    }
  };
  useEffect(() => {
    return () => {
      if (expenseForm.attachment instanceof File && selectedImageUrl) {
        URL.revokeObjectURL(selectedImageUrl);
      }
    };
  }, [expenseForm.attachment, selectedImageUrl]);

  const unpaidExpenses = useMemo(
    () => expenses.filter((e) => e.paymentStatus === "Unpaid"),
    [expenses]
  );

  const allUnpaidSelected =
    unpaidExpenses.length > 0 &&
    unpaidExpenses.every((e) => selectedExpenseIds.includes(e._id));

  const someUnpaidSelected =
    unpaidExpenses.some((e) => selectedExpenseIds.includes(e._id)) &&
    !allUnpaidSelected;

  const selectedExpensesForPay = useMemo(
    () =>
      expenses.filter(
        (e) =>
          selectedExpenseIds.includes(e._id) && e.paymentStatus === "Unpaid"
      ),
    [expenses, selectedExpenseIds]
  );

  const selectedPayTotal = useMemo(
    () =>
      selectedExpensesForPay.reduce(
        (sum, e) => sum + parseFloat(String(e.amount || 0)),
        0
      ),
    [selectedExpensesForPay]
  );

  if (!expensePermissions.view_module) {
    return <Restrict />;
  }
  const token = localStorage.getItem("token");
  const fetchCategories = async (): Promise<void> => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_ADMIN_API_URL}/expense-category/getAllBySearch`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.data.isSuccess) {
        setCategories(response.data.data || []);
      } else {
        toast.error(response.data.message || "Failed to fetch categories");
      }
    } catch (err: any) {
      toast.error(
        err.response?.data?.message ||
          "An error occurred while fetching categories"
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchDoctors = async (): Promise<void> => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_ADMIN_API_URL}/users/getAllSharerDoctors`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.data.isSuccess) {
        setDoctors(response.data.data || []);
      } else {
        toast.error(response.data.message || "Failed to fetch doctors");
      }
    } catch (err: any) {
      toast.error(
        err.response?.data?.message ||
          "An error occurred while fetching doctors"
      );
    } finally {
      setLoading(false);
    }
  };
      const fetchUsers = async (): Promise<void> => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/users/findAllUsers`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.data.isSuccess) {
        setUsers(response.data.data || []);
      } else {
        toast.error(response.data.message || "Failed to fetch users");
      }
    } catch (err: any) {
      toast.error(
        err.response?.data?.message || "An error occurred while fetching users"
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchExpenses = async (): Promise<void> => {
    if (!expensePermissions.view_report) {
      toast.error("You do not have permission to view expenses.");
      return;
    }
    setLoading(true);
    try {
      let url = `${process.env.REACT_APP_ADMIN_API_URL}/expenses/getAllExpenses`;

      // Dynamically create the params object
      const params: any = {
        fromDate,
        toDate,
        ...(selectedDoctor && { doctorId: selectedDoctor._id }),
        ...(activeTab !== 1 && selectedCategory && { expenseCategoryId: selectedCategory._id }),
        ...(selectedPaymentMode && { paymentMode: selectedPaymentMode }),
        ...(selectedPaymentStatus && { paymentStatus: selectedPaymentStatus }),
        ...(selectedCreatedBy && { userId: selectedCreatedBy._id }),
      };

      // If the "Processed" tab is active, add the isProcessed flag
      if (activeTab === 1) {
        params.isProcessed = true;
      } else {
        params.isProcessed = false;
      }

      const response = await axios.get(url, {
        params, // Use the newly created params object
        headers: { Authorization: `Bearer ${token}` },
      });

      const filteredExpenses = response.data.isSuccess
        ? response.data.data || []
        : [];
      setExpenses(filteredExpenses);
      setTotalCount(filteredExpenses.length);
      setSelectedExpenseIds((prev) =>
        prev.filter((id) =>
          filteredExpenses.some(
            (e: Expense) =>
              e._id === id && e.paymentStatus === "Unpaid"
          )
        )
      );
    } catch (err: any) {
      toast.error(
        err.response?.data?.message ||
          "An error occurred while fetching expenses"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleToggleSelectAllUnpaid = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.checked) {
      setSelectedExpenseIds(unpaidExpenses.map((e) => e._id));
    } else {
      setSelectedExpenseIds([]);
    }
  };

  const handleToggleExpenseSelect = (expense: Expense) => {
    if (expense.paymentStatus !== "Unpaid") return;
    setSelectedExpenseIds((prev) =>
      prev.includes(expense._id)
        ? prev.filter((id) => id !== expense._id)
        : [...prev, expense._id]
    );
  };

  const handleOpenMarkPaidDialog = () => {
    if (!selectedExpenseIds.length) {
      toast.warn("Please select at least one unpaid expense");
      return;
    }
    setOpenMarkPaidDialog(true);
  };

  const handleBulkMarkAsPaid = async () => {
    if (!selectedExpenseIds.length) {
      toast.warn("Please select at least one unpaid expense");
      return;
    }
    setMarkingPaid(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ADMIN_API_URL}/expenses/bulkMarkAsPaid`,
        { ids: selectedExpenseIds },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data?.isSuccess) {
        toast.success(
          response.data.message || "Selected expenses marked as Paid"
        );
        setSelectedExpenseIds([]);
        setOpenMarkPaidDialog(false);
        await fetchExpenses();
      } else {
        toast.error(
          response.data?.message || "Failed to mark expenses as Paid"
        );
      }
    } catch (err: any) {
      toast.error(
        err.response?.data?.message ||
          "An error occurred while marking expenses as Paid"
      );
    } finally {
      setMarkingPaid(false);
    }
  };

  const fetchCategorySummary = async (): Promise<void> => {
    if (!expensePermissions.view_report) {
      toast.error("You do not have permission to view expenses.");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_ADMIN_API_URL}/expenses/categoryWiseExpenseSummary`,
        {
          params: {
            fromDate,
            toDate,
            ...(selectedCategory && { expenseCategoryId: selectedCategory._id }),
            ...(selectedDoctor && { doctorId: selectedDoctor._id }),
            ...(selectedCreatedBy && { userId: selectedCreatedBy._id }),
            ...(selectedPaymentMode && { paymentMode: selectedPaymentMode }),
            ...(selectedPaymentStatus && { paymentStatus: selectedPaymentStatus }),
          },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.isSuccess) {
        setCategorySummaryData(response.data.data || []);
      } else {
        toast.error(response.data.message || "Failed to fetch category summary");
      }
    } catch (err: any) {
      toast.error(
        err.response?.data?.message ||
          "An error occurred while fetching category summary"
      );
    } finally {
      setLoading(false);
    }
  };
  const handleEdit = (category: ExpenseCategory): void => {
    if (!expensePermissions.add_expense) {
      toast.error("You do not have permission to edit categories.");
      return;
    }
    setEditCategoryId(category._id);
    setEditCategoryName(category.categoryName);
    setCategoryName(category.categoryName);
  };
  const handleUpdate = async (categoryId: string): Promise<void> => {
    if (!expensePermissions.add_expense) {
      toast.error("You do not have permission to update categories.");
      return;
    }
    setLoading(true);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_ADMIN_API_URL}/expense-category/updateById/${categoryId}`,
        { categoryName: editCategoryName || categoryName },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.isSuccess) {
        toast.success("Category updated successfully");
        setEditCategoryId(null);
        setEditCategoryName("");
        setCategoryName("");
        fetchCategories();
      } else {
        toast.error(response.data.message || "Failed to update category");
      }
    } catch (err: any) {
      toast.error(
        err.response?.data?.message ||
          "An error occurred while updating the category"
      );
    } finally {
      setLoading(false);
    }
  };
  const handleCancelEdit = (): void => {
    setEditCategoryId(null);
    setEditCategoryName("");
    setCategoryName("");
  };
  const handleOpenDeleteDialog = (
    id: string,
    type: "expense" | "category"
  ): void => {
    if (!expensePermissions.add_expense) {
      toast.error(`You do not have permission to delete ${type}s.`);
      return;
    }
    setItemToDelete({ id, type });
    setOpenDeleteDialog(true);
  };
  const handleCloseDeleteDialog = (): void => {
    setOpenDeleteDialog(false);
    setItemToDelete(null);
  };
  const handleDelete = async (): Promise<void> => {
    if (!itemToDelete) return;
    setLoading(true);
    try {
      const url =
        itemToDelete.type === "category"
          ? `${process.env.REACT_APP_ADMIN_API_URL}/expense-category/deleteById/${itemToDelete.id}`
          : `${process.env.REACT_APP_ADMIN_API_URL}/expenses/deleteById/${itemToDelete.id}`;
      const response = await axios.delete(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data.isSuccess) {
        toast.success(
          `${
            itemToDelete.type.charAt(0).toUpperCase() +
            itemToDelete.type.slice(1)
          } deleted successfully`
        );
        if (itemToDelete.type === "category") {
          fetchCategories();
        } else {
          fetchExpenses();
        }
      } else {
        toast.error(
          response.data.message || `Failed to delete ${itemToDelete.type}`
        );
      }
    } catch (err: any) {
      toast.error(
        err.response?.data?.message ||
          `An error occurred while deleting the ${itemToDelete.type}`
      );
    } finally {
      setLoading(false);
      handleCloseDeleteDialog();
    }
  };
  const handleSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    fetchCategories();
    if (!expensePermissions.add_expense) {
      toast.error("You do not have permission to add categories.");
      return;
    }
    if (editCategoryId) {
      await handleUpdate(editCategoryId);
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ADMIN_API_URL}/expense-category/createExpenseCategory`,
        { categoryName },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data.isSuccess) {
        toast.success(
          response.data.message || "Expense category added successfully"
        );
        setCategoryName("");
        setCategories([...categories, response.data.data]);
      } else {
        toast.error(response.data.message || "Failed to add expense category");
      }
    } catch (err: any) {
      toast.error(
        err.response?.data?.message ||
          "An error occurred while adding the expense category"
      );
    } finally {
      setLoading(false);
    }
  };
  const formatIndianNumber1 = (num: any) => {
    const numStr = Math.floor(num).toString();
    const len = numStr.length;
    if (len <= 3) return numStr;
    let result = "";
    let count = 0;
    for (let i = len - 1; i >= 0; i--) {
      if (count === 3 && i !== len - 1) {
        result = "," + result;
        count = 1;
      } else if (count > 3 && (count - 3) % 2 === 0) {
        result = "," + result;
        count = 1;
      } else {
        count++;
      }
      result = numStr[i] + result;
    }
    return result;
  };
  const handleEditExpense = (expense: Expense): void => {
    if (!expensePermissions.add_expense) {
      toast.error("You do not have permission to edit expenses.");
      return;
    }
    console.log("Editing expense:", expense);
    setEditClick(true);
    setEditExpense(expense);
    setExpenseForm({
      expenseCategory:
        expense.category?.categoryName || expense.expenseCategory || "",
      expenseCategoryId:
        expense.expenseCategoryId || expense.category?._id || "",
      description: expense.description || "",
      attachment: expense?.billAttachmentUrl || null,
      amount: expense.amount || 0,
      date: expense.date
        ? new Date(expense.date).toISOString().slice(0, 10)
        : new Date().toISOString().slice(0, 10),
      paymentMode: expense.paymentMode || "Cash",
      paymentStatus: expense.paymentStatus || "Paid",
    });
    setOpen(true);
  };
  const handleExpenseSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    if (!expensePermissions.add_expense) {
      toast.error("You do not have permission to add or update expenses.");
      return;
    }
    if (
      !expenseForm.expenseCategoryId ||
      !expenseForm.description ||
      !expenseForm.amount ||
      !expenseForm.paymentMode ||
      !["Cash", "Online Transaction"].includes(expenseForm.paymentMode) ||
      !expenseForm.paymentStatus
    ) {
      toast.error("Please fill in all required fields with valid values.");
      return;
    }
    setLoading(true);
    try {
      const selectedCategory = categories.find(
        cat => cat._id === expenseForm.expenseCategoryId
      );
      if (editExpense && !(expenseForm.attachment instanceof File)) {
        const updateData = {
          expenseCategoryId: expenseForm.expenseCategoryId,
          expenseCategory: selectedCategory?.categoryName || "",
          description: expenseForm.description,
          amount: expenseForm.amount,
          date: expenseForm.date,
          paymentMode: expenseForm.paymentMode,
          paymentStatus: expenseForm.paymentStatus,
        };
        const response = await axios.patch(
          `${process.env.REACT_APP_ADMIN_API_URL}/expenses/updateById/${editExpense._id}`,
          updateData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data.isSuccess) {
          toast.success(
            response.data.message || "Expense updated successfully"
          );
          setEditExpense(null);
          setExpenseForm({
            expenseCategory: "",
            expenseCategoryId: "",
            description: "",
            attachment: null,
            amount: 0,
            date: new Date().toISOString().slice(0, 10),
            paymentMode: "Cash",
            paymentStatus: "Paid",
          });
          fetchExpenses();
          handleClose();
        } else {
          toast.error(response.data.message || "Failed to update expense");
        }
      } else {
        const formData = new FormData();
        formData.append("expenseCategoryId", expenseForm.expenseCategoryId);
        formData.append(
          "expenseCategory",
          selectedCategory?.categoryName || ""
        );
        formData.append("description", expenseForm.description);
        formData.append("amount", expenseForm.amount.toString());
        formData.append("date", expenseForm.date);
        formData.append("paymentMode", expenseForm.paymentMode);
        formData.append("paymentStatus", expenseForm.paymentStatus);
        if (expenseForm.attachment instanceof File) {
          formData.append("file", expenseForm.attachment);
        }
        const url = editExpense
          ? `${process.env.REACT_APP_ADMIN_API_URL}/expenses/updateById/${editExpense._id}`
          : `${process.env.REACT_APP_ADMIN_API_URL}/expenses/addExpense`;
        const method = editExpense ? "patch" : "post";
        const response = await axios({
          method,
          url,
          data: formData,
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
        if (response.data.isSuccess) {
          toast.success(
            response.data.message ||
              `Expense ${editExpense ? "updated" : "added"} successfully`
          );
          setEditExpense(null);
          setExpenseForm({
            expenseCategory: "",
            expenseCategoryId: "",
            description: "",
            attachment: null,
            amount: 0,
            date: new Date().toISOString().slice(0, 10),
            paymentMode: "Cash",
            paymentStatus: "Paid",
          });
          fetchExpenses();
          handleClose();
        } else {
          toast.error(
            response.data.message ||
              `Failed to ${editExpense ? "update" : "add"} expense`
          );
        }
      }
    } catch (err: any) {
      console.error("Update error:", err);
      toast.error(
        err.response?.data?.message ||
          "An error occurred while processing the expense"
      );
    } finally {
      setLoading(false);
    }
  };
  const handleCancelEditExpense = (): void => {
    setEditExpense(null);
    setExpenseForm({
      expenseCategory: "",
      expenseCategoryId: "",
      description: "",
      attachment: null,
      amount: 0,
      date: new Date().toISOString().slice(0, 10),
      paymentMode: "Cash",
      paymentStatus: "Paid",
    });
  };
  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleExpenseSubmit(e);
  };
  const handleDownloadExcel = () => {
    if (!expensePermissions.print_report) {
      toast.error("You do not have permission to download reports.");
      return;
    }

    let headers: string[] = [];
    let excelData: any[] = [];

    if (activeTab === 2) {
      headers = ["Category Name", "Total Amount", "Count"];
      excelData = categorySummaryData.map(item => ({
        "Category Name": item.categoryName || "N/A",
        "Total Amount": parseFloat(item.totalAmount || 0).toFixed(2),
        Count: item.count || 0,
      }));
    } else {
      headers = [
        "Sr#",
        "Voucher#",
        "Employee",
        "Description",
        "Date",
        "Category",
        "Amount",
        "Paid Amount",
        "Unpaid Amount",
        "Payment Mode",
        "Payment Status",
        "Created At",
      ];

      excelData = expenses.map((expense, index) => ({
        "Sr#": index + 1,
        "Voucher#": expense.voucher || 107163 + index,
        Employee: expense.createdBy?.fullName || "N/A",
        Description: expense.description || "N/A",
        Date: formatDateOnly(expense.date),
        Category:
          categories.find(c => c._id === expense.expenseCategoryId)
            ?.categoryName || "Hospital Expenses",
        Amount: parseFloat(expense.amount.toString()).toFixed(2),
        "Paid Amount": parseFloat((expense.paidAmount || 0).toString()).toFixed(2),
        "Unpaid Amount": parseFloat((expense.pendingAmount || 0).toString()).toFixed(2),
        "Payment Mode": expense.paymentMode || "Cash",
        "Payment Status": expense.paymentStatus || "paid",
        "Created At": formatDateTime(expense.createdAt),
      }));
    }

    // Create a worksheet
    const ws = XLSX.utils.json_to_sheet(excelData, { header: headers });

    // Create a workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Expenses");

    // Generate Excel file and trigger download
    XLSX.writeFile(
      wb,
      activeTab === 2 
        ? `Category_Summary_Report-${new Date().toLocaleDateString()}-${new Date().toLocaleTimeString()}.xlsx`
        : `Expense_Report-${new Date().toLocaleDateString()}-${new Date().toLocaleTimeString()}.xlsx`
    );
  };

  const handlePrint = () => {
    if (activeTab === 2) {
      if (!categorySummaryData.length) return toast.warn("No data to print.");
    } else {
      if (!expenses.length) return toast.warn("No data to print.");
    }

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 8;
    let yPosition = margin;

    // Professional header with minimal, clean design
    doc
      .setFontSize(10)
      .setFont("helvetica", "bold")
      .setTextColor(25, 55, 85)
      .text(
        activeTab === 2 ? "CATEGORY WISE SUMMARY REPORT" : "EXPENSE REPORT",
        pageWidth / 2,
        yPosition,
        {
          align: "center",
        }
      );

    yPosition += 6;
    doc
      .setDrawColor(25, 55, 85)
      .setLineWidth(0.5)
      .line(margin, yPosition, pageWidth - margin, yPosition);

    // Subtle metadata section with smaller font
    yPosition += 3;
    doc
      .setFontSize(6.5)
      .setFont("helvetica", "normal")
      .setTextColor(80, 80, 80)
      .text(
        `Report Period: ${fromDate} to ${toDate} | Generated: ${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`,
        pageWidth / 2,
        yPosition,
        { align: "center" }
      );

    yPosition += 6;

    let head: any[] = [];
    let body: any[] = [];
    let totalAmount = 0;

    if (activeTab === 2) {
      head = [["CATEGORY NAME", "TOTAL AMOUNT", "COUNT"]];
      body = categorySummaryData.map(item => [
        item.categoryName || "N/A",
        formatIndianNumber1(item.totalAmount || 0),
        item.count || 0,
      ]);
      totalAmount = categorySummaryData.reduce(
        (sum, item) => sum + (item.totalAmount || 0),
        0
      );
      body.push([
        "TOTAL",
        formatIndianNumber1(totalAmount),
        categorySummaryData.reduce((sum, item) => sum + (item.count || 0), 0),
      ]);
    } else if (activeTab === 1) {
      head = [
        [
          "SR#",
          "VOUCHER#",
          "MRN",
          "PATIENT NAME",
          "DATE",
          "DOCTOR",
          "AMOUNT",
          "PAID AMOUNT",
          "UNPAID AMOUNT",
          "PAYMENT MODE",
          "PAYMENT STATUS",
          "CREATED AT",
        ],
      ];
      body = expenses.map((expense, index) => [
        index + 1,
        expense.voucher || 107163 + index,
        expense.patientInfo?.mrn || expense.mrn || "N/A",
        expense.patientInfo?.patientName || expense.patientName || "N/A",
        formatDateOnly(expense.date),
        expense.doctorInfo?.fullName || expense.doctorName || "N/A",
        Number(expense.amount || 0).toFixed(2),
        Number(expense.paidAmount || 0).toFixed(2),
        Number(expense.pendingAmount || 0).toFixed(2),
        expense.paymentMode || "Cash",
        expense.paymentStatus || "paid",
        formatDateTime(expense.createdAt),
      ]);
      const totalPaid = expenses.reduce(
        (sum, item) => sum + (Number(item?.paidAmount) || 0),
        0
      );
      const totalUnpaid = expenses.reduce(
        (sum, item) => sum + (Number(item?.pendingAmount) || 0),
        0
      );
      totalAmount = expenses.reduce(
        (sum, item) => sum + (Number(item?.amount) || 0),
        0
      );
      body.push([
        "",
        "",
        "",
        "",
        "",
        "TOTAL",
        Number(totalAmount).toFixed(2),
        Number(totalPaid).toFixed(2),
        Number(totalUnpaid).toFixed(2),
        "",
        "",
        "",
      ]);
    } else {
      head = [
        [
          "SR#",
          "VOUCHER#",
          "EMPLOYEE",
          "DESCRIPTION",
          "DATE",
          "CATEGORY",
          "AMOUNT",
          "PAID AMOUNT",
          "UNPAID AMOUNT",
          "PAYMENT MODE",
          "PAYMENT STATUS",
          "CREATED AT",
        ],
      ];
      body = expenses.map((expense, index) => [
        index + 1,
        expense.voucher || 107163 + index,
        expense.createdBy?.fullName || "N/A",
        expense.description || "N/A",
        formatDateOnly(expense.date),
        categories.find(c => c._id === expense.expenseCategoryId)
          ?.categoryName || "Hospital Expenses",
        Number(expense.amount || 0).toFixed(2),
        Number(expense.paidAmount || 0).toFixed(2),
        Number(expense.pendingAmount || 0).toFixed(2),
        expense.paymentMode || "Cash",
        expense.paymentStatus || "paid",
        formatDateTime(expense.createdAt),
      ]);
      const totalPaidGeneral = expenses.reduce(
        (sum, item) => sum + (Number(item?.paidAmount) || 0),
        0
      );
      const totalUnpaidGeneral = expenses.reduce(
        (sum, item) => sum + (Number(item?.pendingAmount) || 0),
        0
      );
      totalAmount = expenses.reduce(
        (sum, item) => sum + (Number(item?.amount) || 0),
        0
      );
      body.push([
        "",
        "",
        "",
        "",
        "",
        "TOTAL",
        Number(totalAmount).toFixed(2),
        Number(totalPaidGeneral).toFixed(2),
        Number(totalUnpaidGeneral).toFixed(2),
        "",
        "",
        "",
      ]);
    }

    // Clean, professional table styling
    autoTable(doc, {
      startY: yPosition,
      head,
      body,
      headStyles: {
        fillColor: [25, 55, 85],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        fontSize: 6,
        halign: 'center',
        valign: 'middle',
        cellPadding: 2
      },
      bodyStyles: {
        fontSize: 5.5,
        textColor: [40, 40, 40],
        cellPadding: 1.8
      },
      columnStyles:
        activeTab === 2
          ? {
              0: { halign: "center" },
              1: { halign: "center" },
              2: { halign: "center" },
            }
          : {
              0: { halign: "center" },
              1: { halign: "center" },
              2: { halign: "center" },
              3: { halign: "center" },
              4: { halign: "center" },
              5: { halign: "center" },
              6: { halign: "center" },
              7: { halign: "center" },
              8: { halign: "center" },
              9: { halign: "center" },
              10: { halign: "center" },
              11: { halign: "center" },
            },
      alternateRowStyles: {
        fillColor: [248, 249, 250]
      },
      margin: { top: margin, right: margin, bottom: margin, left: margin },
      didParseCell: function(data: any) {
        // Professional total row with premium styling
        if (data.row.index === body.length - 1) {
          data.cell.styles.fillColor = [25, 55, 85];
          data.cell.styles.textColor = [255, 255, 255];
          data.cell.styles.fontStyle = 'bold';
          data.cell.styles.fontSize = 5.8;
          data.cell.styles.lineColor = [200, 200, 200];
          data.cell.styles.lineWidth = 0.3;
          data.cell.styles.lineWidth = 0.3;
          (data.cell.styles as any).cellPadding = {
            top: 2.5,
            right: 2,
            bottom: 2.5,
            left: 2,
          };
        }
      },
      didDrawPage: function(data: any) {
        // Add subtle footer with page number
        const pageSize = doc.internal.pageSize;
        const pageCount = doc.getNumberOfPages();
        const pageNum = data.pageNumber;

        doc.setFontSize(5);
        doc.setTextColor(120, 120, 120);
        doc.text(
          `Page ${pageNum} of ${pageCount}`,
          pageSize.getWidth() / 2,
          pageSize.getHeight() - 4,
          { align: "center" }
        );
      }
    });

    doc.save(
      activeTab === 2
        ? `Category_Summary_Report-${fromDate}_to_${toDate}.pdf`
        : `Expense_Report-${fromDate}_to_${toDate}.pdf`
    );
    toast.success("PDF downloaded successfully");
  };
  const handleOpenImageModal = (attachment: File | string | null) => {
    if (attachment instanceof File) {
      setSelectedImageUrl(URL.createObjectURL(attachment));
    } else if (typeof attachment === "string" && attachment) {
      setSelectedImageUrl(`${attachment}`);
    }
    setOpenImageModal(true);
  };
  const handleCloseImageModal = () => {
    setOpenImageModal(false);
    setSelectedImageUrl(null);
  };
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setEditClick(false);
    setExpenseForm(initialForm);
  };
  return (
    <Box
      sx={{
        background: "#fff",
        p: 1,
        borderRadius: "12px",
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p={1}
        sx={{ background: "#fff", borderRadius: "12px" }}
      >
        <Typography sx={{ fontSize: "18px", fontWeight: "600", color: "#000" }}>
          Expense Management
        </Typography>
        {expensePermissions.add_expense && activeTab === 0 && (
          <Button
            variant="contained"
            onClick={handleOpen}
            disabled={open}
            size="small"
            startIcon={<Add />}
            sx={{
              minWidth: { xs: "auto", md: "100px" },
              fontSize: { xs: "12px", md: "12px" },
              fontWeight: "600",
              textTransform: "none",
              borderRadius: "8px",
              background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)",
              color: "#ffffff",
              boxShadow: "0 3px 5px 2px rgba(25, 118, 210, .3)",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                background: "linear-gradient(45deg, #1565c0 30%, #1e88e5 90%)",
                boxShadow: "0 5px 15px rgba(25, 118, 210, .4)",
                transform: "translateY(-1px)",
              },
              "&:disabled": {
                background: "#b0bec5",
                color: "#ffffff",
                opacity: 0.6,
                cursor: "not-allowed",
              },
              "& .MuiButton-startIcon": {
                marginRight: { xs: "4px", md: "8px" },
              },
            }}
          >
            Add Expense
          </Button>
        )}
      </Box>

      <Box sx={{ mt: 1 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="expense tabs"
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          <Tab label="General Expense" />
          {projectProfile?.departmentsAccess?.includes("Account") && (
            <Tab label="Processed Expense" />
          )}
          {projectProfile?.departmentsAccess?.includes("Account") && (
            <Tab label="Category Wise Summary" />
          )}
        </Tabs>
      </Box>

      <Box sx={{ p: 1 }}>
        {expensePermissions.add_expense && (
          <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth={false}
            PaperProps={{
              sx: { borderRadius: 2, maxWidth: 500, width: "100%" },
            }}
          >
            <DialogTitle>
              {editClick ? "Update Expense" : "Add Expense"}
            </DialogTitle>
            <DialogContent>
              <Box component="form" onSubmit={onSubmit} noValidate>
                <Grid container spacing={2} py={1}>
                  <Grid item xs={12} sm={6}>
                    <FormControl
                      required
                      fullWidth
                      size="small"
                      sx={{ borderRadius: 2 }}
                    >
                      <InputLabel id="category-label">Category</InputLabel>
                      <Select
                        labelId="category-label"
                        value={expenseForm.expenseCategoryId}
                        onChange={e =>
                          setExpenseForm({
                            ...expenseForm,
                            expenseCategoryId: e.target.value,
                          })
                        }
                        label="Category"
                      >
                        {categories.map(cat => (
                          <MenuItem
                            key={cat._id}
                            value={cat._id}
                            sx={{ fontSize: "11px", py: 0.5 }}
                          >
                            {cat.categoryName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl
                      required
                      fullWidth
                      size="small"
                      sx={{ borderRadius: 2 }}
                    >
                      <InputLabel id="payment-mode-label">
                        Payment Mode
                      </InputLabel>
                      <Select
                        labelId="payment-mode-label"
                        className="custom-input"
                        value={expenseForm.paymentMode}
                        onChange={e =>
                          setExpenseForm({
                            ...expenseForm,
                            paymentMode: e.target.value,
                          })
                        }
                        label="Payment Mode"
                      >
                        <MenuItem
                          value="Cash"
                          className="custom-input"
    
                        >
                          Cash
                        </MenuItem>
                        <MenuItem
                          value="Online Transaction"
                        >
                          Online Transaction{" "}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl
                      required
                      fullWidth
                      size="small"
                      sx={{ borderRadius: 2 }}
                    >
                      <InputLabel id="payment-status-label">
                        Payment Status
                      </InputLabel>
                      <Select
                        labelId="payment-status-label"
                        value={expenseForm.paymentStatus}
                        onChange={e =>
                          setExpenseForm({
                            ...expenseForm,
                            paymentStatus: e.target.value,
                          })
                        }
                        label="Payment Status"
                      >
                        <MenuItem value="Paid">Paid</MenuItem>
                        <MenuItem value="Unpaid">Unpaid</MenuItem>
                        <MenuItem value="Partially Paid">Partially Paid</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      fullWidth
                      size="small"
                      type="string"
                      label="Amount"
                      value={expenseForm.amount}
                      onChange={e => {
                        const input = e.target.value;
                        if (input.length <= 8) {
                          const v = Number(input);
                          setExpenseForm({
                            ...expenseForm,
                            amount: isNaN(v) ? 0 : v,
                          });
                        }
                      }}
                      inputProps={{ maxLength: 8, min: 0, max: 99999999 }}
                      sx={{ borderRadius: 2 }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      required
                      fullWidth
                      size="small"
                      type="date"
                      label="Date"
                      value={
                        !expensePermissions.add_previous_expense
                          ? new Date().toISOString().slice(0, 10)
                          : expenseForm.date
                      }
                      onChange={e => {
                        if (expensePermissions.add_previous_expense) {
                          setExpenseForm({
                            ...expenseForm,
                            date: e.target.value,
                          });
                        }
                      }}
                      InputLabelProps={{ shrink: true }}
                      sx={{ borderRadius: 2 }}
                      disabled={!expensePermissions.add_previous_expense}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      required
                      fullWidth
                      size="small"
                      label="Description"
                      multiline
                      minRows={3}
                      maxRows={4}
                      value={expenseForm.description}
                      onChange={e =>
                        setExpenseForm({
                          ...expenseForm,
                          description: e.target.value,
                        })
                      }
                      sx={{ borderRadius: 2, wordBreak: "break-word" }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="body2" fontWeight="bold" mb={1}>
                      Bill attachment
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button
                        component="label"
                        size="small"
                        sx={{
                          background: "#f1f1f3ff",
                          textTransform: "none",
                          borderRadius: 2,
                          "&:hover": { background: "#e0e0e0" },
                        }}
                      >
                        Upload Image
                        <input
                          type="file"
                          accept="image/*"
                          hidden
                          onChange={e => {
                            const file = e.target.files?.[0];
                            if (!file) return;
                            if (!file.type.startsWith("image/")) {
                              toast.error("Select valid image");
                              return;
                            }
                            if (file.size > 5 * 1024 * 1024) {
                              toast.error("Max size 5MB");
                              return;
                            }
                            setExpenseForm({
                              ...expenseForm,
                              attachment: file,
                            });
                          }}
                        />
                      </Button>
                      {expenseForm.attachment && (
                        <Box>
                          <img
                            src={
                              expenseForm.attachment instanceof File
                                ? URL.createObjectURL(expenseForm.attachment)
                                : `${expenseForm.attachment}`
                            }
                            alt="Attachment"
                            style={{
                              minWidth: 80,
                              maxHeight: "100px",
                              objectFit: "contain",
                              borderRadius: 4,
                            }}
                          />
                          <IconButton
                            size="small"
                            onClick={() =>
                              setExpenseForm({
                                ...expenseForm,
                                attachment: null,
                              })
                            }
                          >
                            <DeleteIcon
                              sx={{ fontSize: 16, color: "#FF1F1F" }}
                            />
                          </IconButton>
                        </Box>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="inherit">
                Cancel
              </Button>
              <Button
                onClick={onSubmit}
                variant="contained"
                disabled={
                  loading ||
                  !expenseForm.expenseCategoryId ||
                  !expenseForm.description
                }
              >
                {editClick ? "Update" : "Add"}
              </Button>
            </DialogActions>
          </Dialog>
        )}
        <Divider sx={{ my: 1 }} />
        {expensePermissions.view_report && (
          <Box  
            sx={{
              mb: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              gap: 2,
              flexWrap: "wrap",
            }}
          >

            <Box
              sx={{
                display: "flex",
                alignItems: "flex-end",
                gap: 2,
                flexWrap: activeTab === 0 || activeTab === 2 ? "wrap" : "nowrap",
                justifyContent:
                  activeTab === 0 || activeTab === 2
                    ? { xs: "center", md: "flex-end" }
                    : "flex-end",
              }}
            >
              {(activeTab === 0 || activeTab === 2) && (
                <>
                  {activeTab === 0 && selectedExpenseIds.length > 0 && (
                    <Button
                      variant="contained"
                      size="small"
                      disabled={markingPaid}
                      onClick={handleOpenMarkPaidDialog}
                      sx={{
                        minWidth: { xs: "auto", md: "140px" },
                        fontSize: "12px",
                        fontWeight: "600",
                        textTransform: "none",
                        borderRadius: "8px",
                        background: "linear-gradient(45deg, #2e7d32 30%, #66bb6a 90%)",
                        color: "#ffffff",
                        mb: 0.5,
                        "&:hover": {
                          background: "linear-gradient(45deg, #1b5e20 30%, #43a047 90%)",
                        },
                      }}
                    >
                      {markingPaid
                        ? "Updating..."
                        : `Mark Paid (${selectedExpenseIds.length})`}
                    </Button>
                  )}
                  {expensePermissions.print_report && (
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 0.5 }}>
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<DownloadIcon />}
                      onClick={handlePrint}
                      sx={{
                        minWidth: { xs: "auto", md: "90px" },
                        fontSize: "12px",
                        fontWeight: "600",
                        textTransform: "none",
                        borderRadius: "8px",
                        background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)",
                        color: "#ffffff",
                        boxShadow: "0 3px 5px 2px rgba(25, 118, 210, .3)",
                        "&:hover": {
                          background: "linear-gradient(45deg, #1565c0 30%, #1e88e5 90%)",
                        },
                      }}
                    >
                      PDF
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<DownloadIcon />}
                      onClick={handleDownloadExcel}
                      sx={{
                        minWidth: { xs: "auto", md: "90px" },
                        fontSize: "12px",
                        fontWeight: "600",
                        textTransform: "none",
                        borderRadius: "8px",
                        background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)",
                        color: "#ffffff",
                        boxShadow: "0 3px 5px 2px rgba(25, 118, 210, .3)",
                        "&:hover": {
                          background: "linear-gradient(45deg, #1565c0 30%, #1e88e5 90%)",
                        },
                      }}
                    >
                      Excel
                    </Button>
                  </Box>
                  )}
                  {activeTab === 0 && (
                  <Box sx={{ width: { xs: "100%", md: "125px" } }}>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "#000",
                        mb: 0.5,
                      }}
                    >
                      Payment Status
                    </Typography>
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{
                        maxWidth: "125px",
                      }}
                    >
                      <Select
                        value={selectedPaymentStatus}
                        className="custom-input"
                        onChange={e => setSelectedPaymentStatus(e.target.value)}
                        displayEmpty
                      
                      >
                        <MenuItem value="" sx={{ fontSize: "12px" }}>
                          All
                        </MenuItem>
                        <MenuItem value="Paid" sx={{ fontSize: "12px" }}>
                          Paid
                        </MenuItem>
                        <MenuItem value="Unpaid" sx={{ fontSize: "12px" }}>
                          Unpaid
                        </MenuItem>
                        <MenuItem value="Partially Paid" sx={{ fontSize: "12px" }}>
                          Partially Paid
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                  )}
                  {activeTab === 0 && (
                  <Box sx={{ width: { xs: "100%", md: "150px" } }}>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "#000",
                        mb: 0.5,
                      }}
                    >
                      Created By
                    </Typography>
                    <Autocomplete
                      className="custom-input"
                      size="small"
                      options={users}
                      sx={{
                        background: "#F5F5FB",
                        borderRadius: "12px",
                        "& fieldset": { border: "none" },
                      }}
                      getOptionLabel={option => option.fullName || ""}
                      value={selectedCreatedBy}
                      onChange={(e, newValue) => {
                        setSelectedCreatedBy(newValue);
                      }}
                      renderInput={params => (
                        <TextField {...params} placeholder="Select User" />
                      )}
                      clearOnEscape
                      clearText="Clear"
                    />
                  </Box>
                  )}
                  <Box sx={{ width: { xs: "100%", md: "150px" } }}>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "#000",
                        mb: 0.5,
                      }}
                    >
                      Search by Category
                    </Typography>
                    <Autocomplete
                      className="custom-input"
                      size="small"
                      options={categories}
                      sx={{
                        background: "#F5F5FB",
                        borderRadius: "12px",
                        "& fieldset": { border: "none" },
                      }}
                      getOptionLabel={option => option.categoryName}
                      value={selectedCategory}
                      onChange={(e, newValue) => {
                        setSelectedCategory(newValue);
                      }}
                      renderInput={params => (
                        <TextField {...params} placeholder="Select Category" />
                      )}
                      clearOnEscape
                      clearText="Clear"
                    />
                  </Box>
                </>
              )}
              {activeTab === 1 && (
                <>
                  <Box sx={{ width: { xs: "100%", md: "150px" } }}>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "#000",
                        mb: 0.5,
                      }}
                    >
                      Search by Doctor
                    </Typography>
                    <Autocomplete
                      className="custom-input"
                      size="small"
                      options={doctors}
                      sx={{
                        background: "#F5F5FB",
                        borderRadius: "12px",
                        "& fieldset": { border: "none" },
                      }}
                      getOptionLabel={option =>
                        option.fullName ||
                        `${option.firstName} ${option.lastName || ""}`.trim()
                      }
                      value={selectedDoctor}
                      onChange={(e, newValue) => {
                        setSelectedDoctor(newValue);
                      }}
                      renderInput={params => (
                        <TextField {...params} placeholder="Select Doctor" />
                      )}
                      clearOnEscape
                      clearText="Clear"
                    />
                  </Box>
                </>
              )}
              <Box sx={{ width: { xs: "100%", md: "110px" } }}>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "#000",
                    mb: 0.5,
                  }}
                >
                  Payment Mode
                </Typography>
                <FormControl
                  fullWidth
                  size="small"
                  sx={{
                    maxWidth: "110px",
                  }}
                >
                  <Select
                    value={selectedPaymentMode}
                    className="custom-input"
                    onChange={(e) => setSelectedPaymentMode(e.target.value)}
                    displayEmpty
                  >
                    <MenuItem value="" sx={{ fontSize: "12px" }}>
                      All
                    </MenuItem>
                    <MenuItem value="Cash" sx={{ fontSize: "12px" }}>
                      Cash
                    </MenuItem>
                    <MenuItem value="Online Transaction" sx={{ fontSize: "12px" }}>
                      Online
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <DateRangeSelector
                compact
                dateRange={dateRange}
                fromDate={fromDate}
                toDate={toDate}
                onDateRangeChange={handleDateRangeChange}
                onFromDateChange={setFromDate}
                onToDateChange={setToDate}
                permissions={expensePermissions}
              />
              {/* <Button
                                variant="contained"
                                size="small"
                                onClick={fetchExpenses}
                                sx={{
                                    minWidth: { xs: 'auto', md: '80px' },
                                    fontSize: { xs: '12px', md: '12px' },
                                    fontWeight: '600',
                                    textTransform: 'none',
                                    borderRadius: '8px',
                                    background: 'linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)',
                                    color: '#ffffff',
                                    boxShadow: '0 3px 5px 2px rgba(25, 118, 210, .3)',
                                    transition: 'all 0.3s ease-in-out',
                                    '&:hover': {
                                        background: 'linear-gradient(45deg, #1565c0 30%, #1e88e5 90%)',
                                        boxShadow: '0 5px 15px rgba(25, 118, 210, .4)',
                                        transform: 'translateY(-1px)',
                                    },
                                    '&:disabled': {
                                        background: '#b0bec5',
                                        color: '#ffffff',
                                        opacity: 0.6,
                                        cursor: 'not-allowed',
                                    },
                                    '& .MuiButton-startIcon': {
                                        marginRight: { xs: '4px', md: '8px' },
                                    },
                                }}
                            >
                                Search
                            </Button> */}
              {/* <Box
                                sx={{
                                    backgroundColor: "#6af39cff",
                                    color: "black",
                                    px: 2,
                                    py: 0.8,
                                    borderRadius: "8px",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    boxShadow: "0 2px 4px rgba(168, 157, 157, 0.1)",
                                    minWidth: "150px",
                                    textAlign: "center",
                                }}
                            >
                                Total: PKR {formatIndianNumber1(totalAmount)}.
                                {totalAmount.toFixed(2).split(".")[1] || "0"}
                            </Box> */}
            </Box>
          </Box>
        )}
        <Divider sx={{ my: 1 }} />
        {expensePermissions.view_report && (
          <Box
            sx={{
              maxHeight: "550px",
              overflowY: "hidden",
              "&::-webkit-scrollbar": { width: "6px" },
              "&::-webkit-scrollbar-thumb": { backgroundColor: "#077DD3" },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "rgba(7, 125, 211, 0.24)",
              },
            }}
          >
            
            <Box sx={{ position: "relative" }}>
              <DynamicTable
                headers={
                  activeTab === 2
                    ? ["Category Name", "Total Amount", "Count"]
                    : [
                        ...(activeTab === 0
                          ? [
                              <Checkbox
                                key="select-all"
                                size="small"
                                sx={{
                                  color: "#fff",
                                  p: 0,
                                  "&.Mui-checked": { color: "#fff" },
                                  "&.MuiCheckbox-indeterminate": {
                                    color: "#fff",
                                  },
                                }}
                                checked={allUnpaidSelected}
                                indeterminate={someUnpaidSelected}
                                disabled={unpaidExpenses.length === 0}
                                onChange={handleToggleSelectAllUnpaid}
                                inputProps={{
                                  "aria-label": "Select all unpaid expenses",
                                }}
                              />,
                            ]
                          : []),
                        "SN",
                        "Voucher ID",
                        ...(activeTab === 0 ? ["Description"] : []),
                        ...(activeTab === 1 ? ["MRN", "Patient Name"] : []),
                        "Date",
                        ...(activeTab === 0 ? ["Category"] : ["Doctor"]),
                        "Payment Mode",
                        "Payment Status",
                        "Amount",
                        "Paid Amount",
                        "Unpaid Amount",
                        "Created At",
                        "Created By",
                        "Updated At",
                        "Updated By",
                        ...(activeTab === 0 ? ["Attachment", "Actions"] : []),
                      ]
                }
                data={
                  activeTab === 2
                    ? categorySummaryData.map(item => [
                        item.categoryName || "N/A",
                        formatIndianNumber1(item.totalAmount || 0),
                        item.count || 0,
                      ])
                    : expenses.map((expense, index) => [
                        ...(activeTab === 0
                          ? [
                              <Checkbox
                                key={expense._id}
                                size="small"
                                checked={selectedExpenseIds.includes(expense._id)}
                                disabled={expense.paymentStatus !== "Unpaid"}
                                onChange={() =>
                                  handleToggleExpenseSelect(expense)
                                }
                                inputProps={{
                                  "aria-label": `Select expense ${expense.voucher}`,
                                }}
                              />,
                            ]
                          : []),
                        page * rowsPerPage + index + 1,
                        expense.voucher || "N/A",
                        ...(activeTab === 0
                          ? [expense.description || "N/A"]
                          : []),
                        ...(activeTab === 1
                          ? [
                              expense.patientInfo?.mrn || expense.mrn || "N/A",
                              expense.patientInfo?.patientName ||
                                expense.patientName ||
                                "N/A",
                            ]
                          : []),
                        formatDateTime(expense.date),
                        ...(activeTab === 0
                          ? [expense.category?.categoryName || "Uncategorized"]
                          : [
                              expense.doctorInfo?.fullName ||
                                expense.doctorName ||
                                "N/A",
                            ]),
                        expense.paymentMode || "N/A",
                        expense.paymentStatus || "N/A",
                        `${formatIndianNumber1(
                          parseFloat(expense.amount.toString())
                        )}.${
                          parseFloat(expense.amount.toString())
                            .toFixed(2)
                            .split(".")[1] || "00"
                        }`,
                        `${formatIndianNumber1(
                          parseFloat((expense.paidAmount || 0).toString())
                        )}.${
                          parseFloat((expense.paidAmount || 0).toString())
                            .toFixed(2)
                            .split(".")[1] || "00"
                        }`,
                        <span style={{ color: "red" }}>
                          {`${formatIndianNumber1(
                            parseFloat((expense.pendingAmount || 0).toString())
                          )}.${
                            parseFloat((expense.pendingAmount || 0).toString())
                              .toFixed(2)
                              .split(".")[1] || "00"
                          }`}
                        </span>,
                        formatDateTime(expense.createdAt),
                        expense.createdBy?.fullName ||
                          expense.createdBy?.firstName ||
                          "N/A",
                        expense.updatedAt
                          ? formatDateTime(expense.updatedAt)
                          : "N/A",
                        expense.updatedBy?.fullName ||
                          expense.updatedBy?.firstName ||
                          "N/A",
                        expense.billAttachmentUrl ? (
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <img
                              src={`${expense.billAttachmentUrl}`}
                              alt="Attachment"
                              style={{
                                width: "40px",
                                height: "35px",
                                objectFit: "cover",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                handleOpenImageModal(
                                  expense.billAttachmentUrl || null
                                )
                              }
                              onError={e => {
                                e.currentTarget.style.display = "none";
                                const nextSibling = e.currentTarget
                                  .nextSibling as HTMLElement;
                                if (nextSibling)
                                  nextSibling.style.display = "block";
                              }}
                            />
                            <Typography
                              variant="body2"
                              sx={{ display: "none" }}
                            >
                              Unable to load image
                            </Typography>
                          </Box>
                        ) : (
                          activeTab === 0 && (
                            <Typography variant="body2">No image</Typography>
                          )
                        ),
                      ])
                }
                height="400px"
                page={page}
                totalRows={
                  activeTab === 2 ? categorySummaryData.length : totalCount
                }
                totalAmount={totalAmount}
                totalPaidAmount={totalPaidAmount}
                totalUnpaidAmount={totalUnpaidAmount}
                rowsPerPage={rowsPerPage}
                handleChangePage={(e, newPage) => setPage(newPage)}
                handleChangeRowsPerPage={e => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(0);
                }}
                actionButtons={
                  expensePermissions.add_expense && activeTab === 0
                    ? [
                        {
                          icon: (
                            <EditIcon
                              sx={{
                                height: 20,
                                width: 20,
                                cursor: "pointer",
                                color: () =>
                                  !expensePermissions?.can_edit
                                    ? "grey"
                                    : "#FFB800",
                                "&:hover": {
                                  color: () =>
                                    !expensePermissions?.can_edit
                                      ? "grey"
                                      : "rgb(133, 96, 1)",
                                },
                              }}
                            />
                          ),
                          onClick: rowIndex =>
                            handleEditExpense(expenses[rowIndex]),
                          disabled: () => !expensePermissions?.can_edit,
                        },
                        {
                          icon: (
                            <DeleteIcon
                              sx={{
                                height: 20,
                                width: 20,
                                cursor: "pointer",
                                color: () =>
                                  !expensePermissions?.can_delete
                                    ? "grey"
                                    : "#FF1F1F",
                                "&:hover": {
                                  color: () =>
                                    !expensePermissions?.can_delete
                                      ? "grey"
                                      : "rgb(191, 44, 44)",
                                },
                              }}
                            />
                          ),
                          onClick: rowIndex =>
                            handleOpenDeleteDialog(
                              expenses[rowIndex]._id,
                              "expense"
                            ),
                          disabled: () => !expensePermissions?.can_delete,
                        },
                      ]
                    : []
                }
              />
            </Box>
          </Box>
        )}
        {expensePermissions.add_expense && (
          <Dialog
            open={openMainDialog}
            onClose={() => {
              setOpenMainDialog(false);
              setEditCategoryId(null);
              setCategoryName("");
            }}
            fullWidth
            maxWidth="xs"
          >
            <DialogContent>
              <Box sx={{ p: 1 }}>
                <Typography
                  sx={{ fontSize: "16px", fontWeight: "600", color: "#000" }}
                >
                  {editCategoryId
                    ? "Edit Expense Category"
                    : "Create Expense Category"}
                </Typography>
                <Divider sx={{ my: 1 }} />
                <Box component="form" onSubmit={handleSubmit} sx={{ mb: 2 }}>
                  <Typography
                    sx={{ fontSize: "12px", fontWeight: "500", color: "#000" }}
                  >
                    Category Name
                  </Typography>
                  <TextField
                    value={categoryName}
                    onChange={e => {
                      setCategoryName(e.target.value);
                      if (editCategoryId) setEditCategoryName(e.target.value);
                    }}
                    fullWidth
                    size="small"
                    sx={{
                      background: "#F5F5FB",
                      borderRadius: "12px",
                      "& fieldset": { border: "none" },
                    }}
                    required
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    size="small"
                    disabled={loading || !categoryName.trim()}
                    sx={{ backgroundColor: "#055FFC", px: 1, py: 0.5, mt: 1 }}
                  >
                    {loading
                      ? editCategoryId
                        ? "Updating..."
                        : "Creating..."
                      : editCategoryId
                      ? "Update"
                      : "Create Category"}
                  </Button>
                </Box>
                <Divider sx={{ my: 1 }} />
                <Box
                  sx={{
                    maxHeight: "300px",
                    overflowY: "auto",
                    "&::-webkit-scrollbar": { width: "6px" },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#077DD3",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "rgba(7, 125, 211, 0.24)",
                    },
                  }}
                >
                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            Category Name
                          </TableCell>
                          <TableCell sx={{ fontWeight: "bold" }}>
                            Actions
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {categories.map(category => (
                          <TableRow key={category._id}>
                            <TableCell>
                              {editCategoryId === category._id ? (
                                <TextField
                                  value={editCategoryName}
                                  onChange={e => {
                                    setEditCategoryName(e.target.value);
                                    setCategoryName(e.target.value);
                                  }}
                                  size="small"
                                  sx={{
                                    background: "#F5F5FB",
                                    borderRadius: "12px",
                                    "& fieldset": { border: "none" },
                                    width: "100%",
                                  }}
                                  required
                                />
                              ) : (
                                category.categoryName
                              )}
                            </TableCell>
                            <TableCell>
                              <IconButton onClick={() => handleEdit(category)}>
                                <EditIcon
                                  sx={{
                                    color: "#FFB800",
                                    height: 20,
                                    width: 20,
                                    cursor: "pointer",
                                    "&:hover": { color: "rgb(133, 96, 1)" },
                                  }}
                                />
                              </IconButton>
                              <IconButton
                                onClick={() =>
                                  handleOpenDeleteDialog(
                                    category._id,
                                    "category"
                                  )
                                }
                              >
                                <DeleteIcon
                                  sx={{
                                    color: "#FF1F1F",
                                    height: 20,
                                    width: 20,
                                    cursor: "pointer",
                                    "&:hover": { color: "rgb(191, 44, 44)" },
                                  }}
                                />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                size="small"
                variant="outlined"
                onClick={() => {
                  setOpenMainDialog(false);
                  setEditCategoryId(null);
                  setCategoryName("");
                }}
                sx={{
                  borderColor: "#055FFC",
                  color: "#055FFC",
                  px: 1,
                  py: 0.5,
                }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        )}
        {expensePermissions.add_expense && (
          <Dialog
            open={openDeleteDialog}
            onClose={handleCloseDeleteDialog}
            fullWidth
            maxWidth="xs"
          >
            <DialogTitle>Confirm Delete</DialogTitle>
            <DialogContent>
              <Typography>
                Are you sure you want to delete this {itemToDelete?.type}?
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleCloseDeleteDialog}
                variant="outlined"
                size="small"
                sx={{ borderColor: "#055FFC", color: "#055FFC" }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleDelete}
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#FF1F1F",
                  "&:hover": { backgroundColor: "rgb(191, 44, 44)" },
                }}
              >
                Delete
              </Button>
            </DialogActions>
          </Dialog>
        )}

        <Dialog
          open={openMarkPaidDialog}
          onClose={() => !markingPaid && setOpenMarkPaidDialog(false)}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Confirm Mark as Paid</DialogTitle>
          <DialogContent>
            <Typography sx={{ mb: 2 }}>
              The following unpaid expenses will be marked as Paid:
            </Typography>
            <TableContainer sx={{ maxHeight: 280, mb: 2 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: 700 }}>#</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Voucher ID</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Description</TableCell>
                    <TableCell sx={{ fontWeight: 700 }}>Category</TableCell>
                    <TableCell sx={{ fontWeight: 700 }} align="right">
                      Amount
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedExpensesForPay.map((expense, index) => (
                    <TableRow key={expense._id}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{expense.voucher || "N/A"}</TableCell>
                      <TableCell>{expense.description || "N/A"}</TableCell>
                      <TableCell>
                        {expense.category?.categoryName ||
                          expense.expenseCategory ||
                          "Uncategorized"}
                      </TableCell>
                      <TableCell align="right">
                        Rs.{" "}
                        {formatIndianNumber1(
                          parseFloat(String(expense.amount || 0))
                        )}
                        .
                        {parseFloat(String(expense.amount || 0))
                          .toFixed(2)
                          .split(".")[1] || "00"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                bgcolor: "#e8f5e9",
                borderRadius: 1,
                px: 2,
                py: 1.5,
              }}
            >
              <Typography sx={{ fontWeight: 700 }}>
                Total to be Paid ({selectedExpensesForPay.length} item
                {selectedExpensesForPay.length === 1 ? "" : "s"})
              </Typography>
              <Typography sx={{ fontWeight: 700, color: "#2e7d32" }}>
                Rs. {formatIndianNumber1(selectedPayTotal)}.
                {selectedPayTotal.toFixed(2).split(".")[1] || "00"}
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setOpenMarkPaidDialog(false)}
              variant="outlined"
              size="small"
              disabled={markingPaid}
              sx={{ borderColor: "#055FFC", color: "#055FFC" }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleBulkMarkAsPaid}
              variant="contained"
              size="small"
              disabled={markingPaid || selectedExpensesForPay.length === 0}
              sx={{
                backgroundColor: "#2e7d32",
                "&:hover": { backgroundColor: "#1b5e20" },
              }}
            >
              {markingPaid ? "Updating..." : "Confirm Mark Paid"}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
      <Dialog
        open={openImageModal}
        onClose={handleCloseImageModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Image Preview</DialogTitle>
        <DialogContent>
          {selectedImageUrl && (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <img
                src={selectedImageUrl}
                alt="Attachment Preview"
                style={{
                  maxWidth: "100%",
                  maxHeight: "80vh",
                  objectFit: "contain",
                }}
                onError={e => {
                  e.currentTarget.style.display = "none";
                  const nextSibling = e.currentTarget
                    .nextSibling as HTMLElement;
                  if (nextSibling) nextSibling.style.display = "block";
                }}
              />
              <Typography variant="body2" sx={{ display: "none" }}>
                Unable to load image
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseImageModal}
            variant="outlined"
            size="small"
            sx={{ borderColor: "#055FFC", color: "#055FFC" }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
export default ExpenseCategory;
